import React from "react";

// Supplied logo files, unchanged (brand/BRAND.md §11 rules 3-4): -dark assets in the dark theme,
// -light assets in the light theme. Which one shows is decided by CSS on <html data-theme>.
const FILES = {
  horizontal: ["/brand/logo/herdsafe-logo-horizontal-dark.svg", "/brand/logo/herdsafe-logo-horizontal-light.svg"],
  mark: ["/brand/logo/herdsafe-mark-dark.svg", "/brand/logo/herdsafe-mark-light.svg"],
};

export default function Logo({ variant = "horizontal", className = "", alt = "HerdSafe" }) {
  const [dark, light] = FILES[variant];
  return (
    <>
      <img src={dark} alt={alt} className={`hs-dark-only ${className}`} data-testid={`logo-${variant}-dark`} />
      <img src={light} alt={alt} className={`hs-light-only ${className}`} data-testid={`logo-${variant}-light`} />
    </>
  );
}
